import { Component } from '@theme/component';

class LanoelCookiePreferences extends Component {
  openPreferences(event) {
    const link = event.target.closest('a');
    const banner = window.privacyBanner;
    if (!link || typeof banner?.showPreferences !== 'function') return;

    event.preventDefault();
    // Only opens Shopify's existing consent UI; never sets consent itself.
    Promise.resolve(banner.showPreferences()).catch(() => {
      window.location.assign(link.href);
    });
  }
}

if (!customElements.get('lanoel-cookie-preferences')) {
  customElements.define('lanoel-cookie-preferences', LanoelCookiePreferences);
}
